
import { debounce } from '~/plugins/helper'
import routerLink from '~/router-link'

export default {
  data() {
    return {
      isScrolled: false,
      routerLink,
      onScroll: null
    }
  },
  mounted() {
    this.onScroll = debounce(this.handleScroll, 10)
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    handleScroll() {
      const scrollTop = window.scrollY
      if (scrollTop > 0 && window.innerWidth >= 1280) {
        this.isScrolled = true
      } else {
        this.isScrolled = false
      }
    }
  }
}
